import '../lib/url';
import toast from './toast.js';

let isInWxa = false;
let isInJDWxa = false;

try {
  wx.miniProgram.getEnv((res) => {
    isInWxa = res.miniprogram;
  });
  jd.miniProgram.getEnv((res) => {
    isInJDWxa = res.miniprogram;
  });
} catch (error) {
  //
}

export default {
  dev: '',
  urlBase: '',
  apiBase: '',
  params: null,
  env: '',

  // 空函数
  noop() {},

  /**
   * 初始化
   */
  init() {
    // 开发环境
    this.dev =
      location.hostname === 'h5.11visa.com'
        ? 0
        : location.hostname === 'testh5.11visa.com'
        ? 1
        : 2;

    // 参数
    this.params = url('?') || {};

    // 运行环境
    this.env = this.params.p || 'app';

    // 接口地质
    this.urlBase =
      this.dev === 2
        ? 'https://devapi.11visa.com/'
        : this.dev === 1
        ? 'https://testapi.11visa.com/'
        : 'https://api.11visa.com/';

    return this;
  },

  /**
   * 设置浏览器的title
   */
  setTitle(title) {
    document.title = title;
  },

  isPC() {
    if (
      navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i,
      )
    ) {
      return false; // 手机
    }
    return true;
  },

  /**
   * 是否是微信
   */
  isWeixin() {
    const ua = navigator.userAgent.toLowerCase();
    return ua.match(/MicroMessenger/i) === 'micromessenger';
  },

  /**
   * 获取是平台
   */
  getOS() {
    const ua = navigator.userAgent.toLowerCase();
    let os = '';

    if (/iphone|ipad|ipod/.test(ua)) {
      os = 'ios';
    } else if (/android/.test(ua)) {
      os = 'android';
    } else if (/windows/.test(ua)) {
      os = 'windows';
    } else {
      os = 'other';
    }

    return os;
  },

  isSafari() {
    const userAgent = navigator.userAgent;
    if (userAgent.indexOf('Safari') > -1) {
      return 1;
    }
  },

  // 是否在小程序内
  isWxa() {
    return isInWxa;
  },

  // 是否在jd小程序内
  isJDWxa() {
    return isInJDWxa;
  },

  /**
   * 获取平台
   */
  getPlatform() {
    const os = this.getOS();

    if (os === 'ios' || os === 'android') {
      return 'mobile';
    }
    return 'pc';
  },

  // 电话号码格式化
  phoneFormate(phone) {
    return `${phone.substr(0, 3)}****${phone.substr(7)}`;
  },

  /**
   * 获取JS桥
   */
  getBridge(callback) {
    if (window.WebViewJavascriptBridge) {
      return callback(WebViewJavascriptBridge);
    }
    if (this.getOS() !== 'ios') {
      document.addEventListener(
        'WebViewJavascriptBridgeReady',
        () => {
          callback(WebViewJavascriptBridge);
        },
        false,
      );
      return;
    }

    if (window.WVJBCallbacks) {
      return window.WVJBCallbacks.push(callback);
    }
    window.WVJBCallbacks = [callback];
    const WVJBIframe = document.createElement('iframe');
    WVJBIframe.style.display = 'none';
    WVJBIframe.src = 'wvjbscheme://__BRIDGE_LOADED__';
    document.documentElement.appendChild(WVJBIframe);
    setTimeout(() => {
      document.documentElement.removeChild(WVJBIframe);
    }, 0);
  },

  bridgeInit() {
    const _this = this;
    _this.getBridge((bridge) => {
      if (_this.getOS() === 'android') {
        bridge.init((message, responseCallback) => {
          responseCallback({
            loaded: true,
          });
        });
      }
    });
  },

  /**
   * 根据参数名字获取参数值
   *
   * @param {any} name
   * @returns
   */
  getParamByName(name) {
    if (!location.href.split(`${name}=`)[1]) return;
    return location.href.split(`${name}=`)[1].split('&')[0];
  },

  /**
   * 随机字符
   * @param {any} len
   * @returns
   */
  ranString(len) {
    len = len || 32;
    const $chars =
      'abcdefghijklmnopqrstuvwxyz1234567890'; /** **默认去掉了容易混淆的字符oOLl,9gq,Vv,Uu,I1*** */
    const maxPos = $chars.length;
    let ranstr = '';
    for (let i = 0; i < len; i++) {
      ranstr += $chars.charAt(Math.floor(Math.random() * maxPos));
    }
    return ranstr;
  },

  /**
   * 范围内随机数
   */
  ranNumber(min = 0, max = 999) {
    const range = max - min;
    const ran = Math.random();
    const ranNumber = Math.round(min + range * ran);

    return ranNumber;
  },

  /**
   * 跳转下载
   */
  goDownload() {
    MtaH5.clickStat('download_pdv_app');
    const os = this.getOS();
    const inWeixin = this.isWeixin();

    if (inWeixin) {
      location.href = 'https://a.app.qq.com/o/simple.jsp?pkgname=com.pandavisa';
    } else if (os === 'ios') {
      location.href =
        'https://itunes.apple.com/cn/app/xiong-mao-qian-zheng/id1111127921';
    } else {
      location.href =
        'http://webppbb.oss-cn-shenzhen.aliyuncs.com/apk/xmqz.apk';
    }
  },

  // 判断是不是微信浏览器
  isInWeiXin() {
    const ua = window.navigator.userAgent.toLowerCase();
    if (ua.match(/MicroMessenger/i) === 'micromessenger') {
      return true;
    }
    return false;
  },

  // 判断是不是QQ浏览器
  isInQQ() {
    if (navigator.userAgent.indexOf('MQQBrowser') !== -1) {
      return true;
    }
    return false;
  },

  /**
   * 简单克隆
   */
  clone(obj) {
    return JSON.parse(JSON.stringify(obj));
  },

  /*
   *获取滚动条的位置
   */
  scrollTop() {
    return document.body.scrollTop || document.documentElement.scrollTop;
  },

  /*
   *垂直方向滚动到某个位置
   */
  goTo(toTop, time, callback) {
    // 初始scrollTop
    const st = document.body.scrollTop || document.documentElement.scrollTop;
    // 缓动动画函数: 先快后慢
    function esae(t) {
      return t * 2 < 1 ? 4 * t * t * t : 4 * (t - 1) * (t - 1) * (t - 1) + 1;
    }

    let start;
    function animate(timestamp) {
      // timestamp 为requestAnimationFrame传入的一个时间戳,15ms左右
      if (!start) start = timestamp;

      const ds = timestamp - start;

      const dp = ds / time;
      scrollTo(0, st + (toTop - st) * esae(dp));

      if (ds < time) {
        requestAnimationFrame(animate);
      } else {
        scrollTo(0, toTop);
        if (callback) {
          callback();
        }
      }
    }
    requestAnimationFrame(animate);
  },

  // rem转px
  rem2px(rem) {
    if (!rem) {
      return 0;
    }

    const winWidth = document.documentElement.clientWidth;
    let px = 0;
    if (winWidth <= 320) {
      px = rem * (500 / 6.25);
    } else {
      px = rem * (625 / 6.25);
    }

    return px;
  },

  /*
   *获取盒子到最顶部的距离
   */
  getOffsetTop(el) {
    const rect = el.getBoundingClientRect();
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const clientTop = document.documentElement.clientTop || 0;

    return rect.top + rect.height + scrollTop - clientTop;
  },

  // 获取ua信息和环境
  getFullUA() {
    return {
      // 移动终端浏览器版本信息
      trident: navigator.userAgent.indexOf('Trident') > -1, // IE内核
      presto: navigator.userAgent.indexOf('Presto') > -1, // opera内核
      webKit: navigator.userAgent.indexOf('AppleWebKit') > -1, // 苹果、谷歌内核
      gecko:
        navigator.userAgent.indexOf('Gecko') > -1 &&
        navigator.userAgent.indexOf('KHTML') === -1, // 火狐内核
      mobile: !!navigator.userAgent.match(/AppleWebKit.*Mobile.*/), // 是否为移动终端
      ios: !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), // ios终端
      android:
        navigator.userAgent.indexOf('Android') > -1 ||
        navigator.userAgent.indexOf('Linux') > -1, // android终端或uc浏览器
      iPhone: navigator.userAgent.indexOf('iPhone') > -1, // 是否为iPhone或者QQHD浏览器
      iPad: navigator.userAgent.indexOf('iPad') > -1, // 是否iPad
      webApp: navigator.userAgent.indexOf('Safari') === -1, // 是否web应该程序，没有头部与底部
      qq: navigator.userAgent.indexOf(' QQ') > -1,
      wx: navigator.userAgent.indexOf('MicroMessenger') > -1,
    };
  },

  // 根据URL获取文件名和后缀
  getFileInfoByUrl(url) {
    if (!url) return {};
    // 把目录等去除
    let fullFileName = url.split('/').pop();
    // 把？号后面参数去除
    fullFileName = fullFileName.split('?')[0];

    const dotIndex = fullFileName.lastIndexOf('.');

    return {
      filename: fullFileName.substring(0, dotIndex),
      suffix: fullFileName.substring(dotIndex + 1),
    };
  },

  // 请求通用处理
  getResponseData(response) {
    if (!response || !response.data) {
      return {
        data: null,
        err: { msg: '网络出了点小问题，请稍后再试' },
      };
    }

    const data = response.data;

    if (data.ret === 0) {
      return {
        data: data.body,
        err: null,
      };
    }

    return {
      data: null,
      err: data,
    };
  },
  // 通用请求失败处理
  showError(error) {
    if (error && error.msg) {
      return toast.show(error.msg);
    }
    if (error && typeof error === 'string') {
      return toast.show(error);
    }
    toast.show('网络不给力，请稍后再试');
  },
  getLocationSearchParams() {
    const params = {};
    if (location.search && location.search.indexOf('?') > -1) {
      const splitResult = location.search.split('?');
      if (splitResult && splitResult.length > 1) {
        const paramStr = splitResult[1];
        if (paramStr.indexOf('&') > -1) {
          const resultPair = paramStr.split('&');
          if (resultPair && resultPair.length > 0) {
            resultPair.forEach((pair) => {
              const tempResult = pair.split('=');
              params[tempResult[0]] = tempResult[1];
            });
          }
        } else {
          const result = paramStr.split('=');
          params[result[0]] = result[1];
        }
      }
    }
    return params;
  },
};
